"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCounter;

// پلاگین‌ها رو extend می‌کنیم
// dayjs.extend(jalaliday);
// dayjs.extend(relativeTime);
function parseMilliseconds(ms = 0) {
  let seconds = Math.floor(ms / 1000 % 60);
  let minutes = Math.floor(ms / (1000 * 60) % 60);
  let hours = Math.floor(ms / (1000 * 60 * 60));
  hours = hours < 10 ? "0" + hours : hours;
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return [hours, minutes, seconds];
}

let timeout_id;

function useCounter(input, start) {// const [desiredDate, setDesiredDate] = useState<string | undefined>(input);
  // const [timer, setTimer] = useState<number | undefined>();
  // // تبدیل ورودی به Dayjs object معتبر
  // const finalDate = desiredDate
  //   ? dayjs(desiredDate).calendar("jalali")
  //   : dayjs();
  // if (!finalDate.isValid()) {
  //   console.warn("Invalid date:", desiredDate);
  // }
  // // محاسبه اختلاف با زمان فعلی
  // const diff = finalDate.isValid()
  //   ? finalDate.diff(dayjs(), "milliseconds")
  //   : 0;
  // useEffect(() => {
  //   // هر ثانیه diff رو به‌روزرسانی می‌کنیم
  //   timeout_id = setTimeout(() => {
  //     if (diff >= 0) {
  //       setTimer(diff);
  //     } else {
  //       setTimer(0);
  //     }
  //   }, 1000);
  //   return () => clearTimeout(timeout_id);
  // }, [diff]);
  // // وقتی input تغییر کرد، timer و desiredDate ریست می‌شوند
  // useEffect(() => {
  //   setTimer(undefined);
  //   setDesiredDate(input);
  // }, [input]);
  // // وقتی start false شد، همه چیز ریست شود
  // useEffect(() => {
  //   if (!start) {
  //     setTimer(undefined);
  //     setDesiredDate(undefined);
  //     clearTimeout(timeout_id);
  //   }
  // }, [start]);
  // const [hours, minutes, seconds] = parseMilliseconds(timer);
  // let text: string | undefined;
  // if (diff > 0) {
  //   text = `${formatNumber(dayjs(desiredDate).fromNow(true))} دیگر`;
  // } else {
  //   text = "";
  // }
  // return { text };
}